import { Injectable } from '@angular/core';
import { Data } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class BannerCacheService {
  private cache = new Map<string, { data: Data[]; timestamp: number }>();
  private readonly CACHE_DURATION = 15 * 60 * 1000; // 15 minutes

  getCachedBanners(userId: string): Data[] | null {
    const cached = this.cache.get(userId);
    if (cached && (Date.now() - cached.timestamp) < this.CACHE_DURATION) {
      return cached.data;
    }
    return null;
  }

  setCachedBanners(userId: string, banners: Data[]): void {
    this.cache.set(userId, {
      data: banners,
      timestamp: Date.now()
    });
  }

  clearCache(userId?: string): void {
    if (userId) {
      this.cache.delete(userId);
    } else {
      this.cache.clear();
    }
  }
} 